import T from 'prop-types';
import { Button } from '../../Button/Button';
import { jsx as _jsx } from "react/jsx-runtime";

const Action = ({
  children,
  onClick
}) => /*#__PURE__*/_jsx(Button, {
  variant: "tertiary",
  size: "xsmall",
  onClick: onClick,
  children: children
});

Action.propTypes = {
  children: T.node.isRequired,
  onClick: T.func.isRequired
};
export { Action };